import React from 'react'
import Avatar from '@bt-react/components/Avatar'
import style from './UserCard.module.scss'
import { UserCardProps } from './types'
import classnames from 'classnames'
import { getEnvironment, getUserPhotoUrl } from '@bt-react/libs'

const UserCard: React.FC<UserCardProps> = ({ name = '', photoId = '', opaque = false, title = '', avatarClasses = '', showPresenterDetails = true, size = 'md', inSidebar = false }) => {

  const environment = getEnvironment()
  return <div className={
    classnames(
      style['usercard__container'], {
        [style['usercard__container--opaque']]: opaque,
        [style['usercard-sm']]: size === 'sm',
        [style['usercard-xs']]: size === 'xs'
      }
    )}
  >
    <div className={
      classnames(
        style[`usercard__user-card`], {
          [style['usercard__user-card--no-text']]: !showPresenterDetails
        }
      )} data-bdd={`talks-screen-usercard`}>
      <div className={
        classnames(
          style['usercard__avatar'],
          {
            [style['usercard--no-margin']]: size !== 'md'
          },
          avatarClasses
        )}>
        {
          size !== 'xs' &&
          <Avatar src={getUserPhotoUrl(photoId, '160', environment.env === 'stage' || environment.env === 'prod' ? 'brighttalkprod' : 'brighttalkint') || ''} size={size} />
        }
      </div>
      {
        showPresenterDetails &&
        <div className={style['usercard__title']} data-bdd={`${inSidebar ? 'talks-screen-usercard-details-sidebar' : 'talks-screen-usercard-details'}`}>
          <div className={style['usercard__user-name']} data-bdd={`${inSidebar ? 'talks-screen-usercard-name-sidebar' : 'talks-screen-usercard-name'}`}>{name}</div>
          <div className={style['usercard__user-title']} data-bdd={`${inSidebar ? 'talks-screen-usercard-title-sidebar' : 'talks-screen-usercard-title'}`}>{title}</div>
        </div>
      }
    </div>
  </div>

}

export default UserCard
